// extracted by mini-css-extract-plugin
export default {"product-container":"Products_product-container__hg4Jt","products":"Products_products__1OLO3"};